import "./DirectPartMarking.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import WhatIsDirectPartMarking from "./sections/WhatIsDirectPartMarking";
import MarkThePartOrAttachATag from "./sections/MarkThePartOrAttachATag";
import DpmMethods from "./sections/DpmMethods";
import WhatADirectPartMarkContains from "./sections/WhatADirectPartMarkContains";
import StandardsTraceability from "./sections/StandardsTraceability";
import DpmSpecifications from "./sections/DpmSpecifications";
import WhoUsesDpmOemPrograms from "./sections/WhoUsesDpmOemPrograms";
import HowToStart from "./sections/HowToStart";
import Faq from "./sections/Faq";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function DirectPartMarkingPage() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <WhatIsDirectPartMarking />
      <MarkThePartOrAttachATag />
      <DpmMethods />
      <WhatADirectPartMarkContains />
      <StandardsTraceability />
      <DpmSpecifications />
      <WhoUsesDpmOemPrograms />
      <HowToStart />
      <Faq />
      <ClosingCta />
      <Footer />
    </div>;
}